import {useMutation, useQueryClient} from 'react-query';
import api from 'utils/api';

import {userProfileQueryKeys} from 'actions/userProfile';
import userSettingsKeys from './queryKeys';

async function updateUserSettings(settings) {
	return api('patch', '/api/me/settings', null, settings);
}

function useUpdateUserSettings() {
	const queryClient = useQueryClient();

	const {isLoading, isError, mutateAsync} = useMutation(updateUserSettings, {
		onSuccess: (response, changes) => {
			queryClient.setQueryData(
				userSettingsKeys.userSettings,
				settings => ({
					...settings,
					...changes,
				})
			);
			queryClient.setQueryData(
				userProfileQueryKeys.userProfile,
				profile => ({
					...profile,
					settings: {
						...profile.settings,
						...changes,
					},
				})
			);
			queryClient.invalidateQueries(
				userSettingsKeys.userSettings,
				userProfileQueryKeys.userProfile
			);
		},
	});

	return {isLoading, isError, updateUserSettings: mutateAsync};
}

export default useUpdateUserSettings;
